/** @jsxImportSource @emotion/react */
import { Divider } from "../../../../components/Divider";
import { RouteFullScreenModal } from "../../../../components/RouteFullScreenModal";
import { MutateBalanceAccountForm } from "../components/MutateBalanceAccountForm";

export const NewBalanceAccountPage = () => {
  return (
    <RouteFullScreenModal title="New balance account">
      <Divider />
      <MutateBalanceAccountForm />
    </RouteFullScreenModal>
  );
};
